// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"372":"25821f57","2134":"25821f57","2979":"913e6e5c","3907":"25821f57","4159":"99ba69c8","7255":"25821f57","7746":"5d9d3897","8718":"25821f57"}[chunkId] + ".chunk.css";
};